import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { GlobalErrorHandler } from '../services/GloabalErrorHandler.services';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { NgxEditorModule } from 'ngx-editor';
import { ModuleRegistry } from '@ag-grid-community/core';
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { SharedModule } from '../shared-module/shared-module.module';
import { AngularSplitModule } from 'angular-split';
import { TreeviewModule } from '@soy-andrey-semyonov/ngx-treeview';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { JsonEditorModule } from '../json-editor-module/json-editor.module';

ModuleRegistry.registerModules([
  CsvExportModule
]);



const maskConfig: Partial<IConfig> = {
    validation: false,
  };

@NgModule({
    imports:[
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        // O BrowserAnimationsModule NAO entra em modulo de funcionalidade: ele importa
        // o BrowserModule por dentro, e cai no mesmo NG05100 quando um componente
        // standalone que importe este modulo instancia os providers num injetor
        // proprio. As animacoes ja sao providas uma vez pelo AppModule.
        // Sem BrowserModule: o CommonModule acima ja basta, e importa-lo aqui
        // fazia o construtor dele rodar de novo dentro do injetor de um
        // componente standalone que importe este modulo (NG05100).
        NzModalModule,
        DragDropModule,
        ClipboardModule,
        TreeviewModule.forRoot(),
        AngularSplitModule,
        TranslateModule,
        JsonEditorModule,
        NgxEditorModule.forRoot({
            locals: {
                bold: 'Negrito',
                italic: 'Itálico',
                code: 'Código',
                blockquote: 'Comentário',
                underline: 'Sublinhado',
                strike: 'Tachado',
                bullet_list: 'Marcadores',
                ordered_list: 'Numeração',
                heading: 'Cabeçalho',
                h1: 'Cabeçalho 1',
                h2: 'Cabeçalho 2',
                h3: 'Cabeçalho 3',
                h4: 'Cabeçalho 4',
                h5: 'Cabeçalho 5',
                h6: 'Cabeçalho 6',
                align_left: 'Alinhar à Esquerda',
                align_center: 'Centralizar',
                align_right: 'Alinhar à Direita',
                align_justify: 'Justificar',
                text_color: 'Cor da Fonte',
                background_color: 'Cor do Fundo',
                url: 'URL',
                text: 'Texto',
                insert: 'Inserir',
                altText: 'Alt Texto',
                title: 'Título',
                remove: 'Remover',
                insertLink: 'Inserir Link',
                removeLink: 'Remover Link',
                insertImage: 'Inserir Imagem'
              
            }}),
        NgxMaskModule.forRoot(maskConfig),
        SharedModule        
    ],
    declarations: [
        
        
      ],
    exports: [
      
    ],
    providers: [
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        }
    ]
})
export class DynamicFormsModule { 
    
  
}
